/**
 * Created by alvinoktavianus on 6/21/17.
 */

import { HOST_URL } from '../constants'

export const UPDATE_PAYMENT_STATUS = `${HOST_URL}/billings/update_payment_status`



// WEBPACK FOOTER //
// ./app/api/billingRedirect/constant.js